import React from 'react';
import { Phone, User, ShieldCheck } from 'lucide-react';

const InternalComplaint = () => {
  const committeeMembers = [
    { id: 1, name: "SURAPANENI VENKATA RAMANA", designation: "Secretary", appointedAs: "CHAIR PERSON", mobile: "9490106278" },
    { id: 2, name: "JANNU SIVA KUMAR", designation: "PRINCIPAL", appointedAs: "Convener", mobile: "8096951451" },
    { id: 3, name: "P SUBRAHMANYAM", designation: "HOD/CME", appointedAs: "Member", mobile: "7013330438" },
    { id: 4, name: "P RAM KUMAR", designation: "Lab Technician", appointedAs: "Member", mobile: "9393397339" },
    { id: 5, name: "P JAGADEESH", designation: "L/MEC", appointedAs: "Member", mobile: "9440236778" },
    { id: 6, name: "JAMI UMA MAHESWARA RAO", designation: "STUDENT", appointedAs: "Member", mobile: "9912104953" },
    { id: 7, name: "BATCHU GIRISH KUMAR", designation: "STUDENT", appointedAs: "Member", mobile: "9059808294" },
    { id: 8, name: "B JALA PANKAJ KUMAR", designation: "STUDENT", appointedAs: "Member", mobile: "9542525888" },
  ];

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8 font-serif">
      <div className="max-w-5xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-200">
        
        {/* Header Section */}
        <div className="bg-slate-800 text-white py-10 px-8 text-center">
          <h1 className="text-3xl font-bold border-b-2 border-slate-600 pb-4 inline-block tracking-wide">
            Internal Complaints Committee
          </h1>
          <p className="mt-4 text-slate-300 italic text-lg">
            (Gender Sensitization Committee against Sexual Harassment - GSCASH)
          </p>
        </div>

        <div className="p-8 md:p-12">
          {/* Functions Section */}
          <section className="mb-12">
            <div className="flex items-center mb-6">
              <ShieldCheck className="text-slate-800 mr-3" size={28} />
              <h2 className="text-2xl font-bold text-slate-800 underline underline-offset-8">
                Functions of Complaints Committee (ICC) or GSCASH
              </h2>
            </div>
            
            <p className="text-gray-700 font-semibold mb-4 text-lg">
              The Internal Complaints Committee shall:
            </p>
            
            <ul className="space-y-4 text-gray-700 leading-relaxed list-outside ml-5">
              <li className="relative pl-6 before:content-['•'] before:absolute before:left-0 before:text-slate-800 before:font-bold">
                Provide assistance if an employee or a student chooses to file a complaint with the police.
              </li>
              <li className="relative pl-6 before:content-['•'] before:absolute before:left-0 before:text-slate-800 before:font-bold">
                Provide mechanisms of dispute <span className="underline decoration-red-400">redressal</span> and dialogue to anticipate and address issues through just and fair conciliation without undermining complainant's right, and minimizes the need for purely punitive approaches that lead to further resentment, alienation or violence.
              </li>
              <li className="relative pl-6 before:content-['•'] before:absolute before:left-0 before:text-slate-800 before:font-bold">
                Protect the safety of the complainant by not divulging the person's identity, and provide the mandatory relief by way of sanctioned leave or relaxation of attendance requirement or transfer to another department or supervisor as required during the <span className="underline decoration-red-400">pendency</span> of the complaint, or also provide for the transfer of the offender.
              </li>
              <li className="relative pl-6 before:content-['•'] before:absolute before:left-0 before:text-slate-800 before:font-bold">
                Ensure that victims or witnesses are not victimized or discriminated against while dealing with complaints of sexual harassment.
              </li>
              <li className="relative pl-6 before:content-['•'] before:absolute before:left-0 before:text-slate-800 before:font-bold">
                Ensure prohibition of retaliation or adverse action against a covered individual because the employed or the student is engaged in protected activity.
              </li>
            </ul>
          </section>

          {/* Committee Table Section */}
          <section>
            <div className="mb-6">
              <h2 className="text-xl font-bold text-slate-800 mb-2">
                Committee Reorganization
              </h2>
              <p className="text-gray-600 italic">
                This committee has been reorganized with the following members:
              </p>
            </div>

            <div className="overflow-x-auto rounded-lg border border-gray-300 shadow-sm">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-slate-100 text-slate-800 uppercase text-sm tracking-wider">
                    <th className="px-4 py-4 border-b border-gray-300 font-bold w-16 text-center">S.No</th>
                    <th className="px-6 py-4 border-b border-gray-300 font-bold">Name of the Committee Member</th>
                    <th className="px-6 py-4 border-b border-gray-300 font-bold">Designation</th>
                    <th className="px-6 py-4 border-b border-gray-300 font-bold text-center">Appointed as</th>
                    <th className="px-6 py-4 border-b border-gray-300 font-bold">Mobile Number</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {committeeMembers.map((member) => (
                    <tr key={member.id} className="hover:bg-slate-50 transition-colors">
                      <td className="px-4 py-4 text-center text-gray-900 font-medium border-r border-gray-200">{member.id}</td>
                      <td className="px-6 py-4 text-gray-900 font-bold uppercase tracking-tight">{member.name}</td>
                      <td className="px-6 py-4 text-gray-700">{member.designation}</td>
                      <td className="px-6 py-4 text-center">
                        <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${
                          member.appointedAs === 'CHAIR PERSON' ? 'bg-amber-100 text-amber-800 border border-amber-200' : 
                          member.appointedAs === 'Convener' ? 'bg-blue-100 text-blue-800 border border-blue-200' : 
                          'bg-gray-100 text-gray-700 border border-gray-200'
                        }`}>
                          {member.appointedAs}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-slate-700 font-mono whitespace-nowrap">
                        <div className="flex items-center">
                          <Phone size={14} className="mr-2 text-slate-400" />
                          {member.mobile}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Footer info */}
        {/* <div className="bg-gray-50 p-6 border-t border-gray-200 text-right text-sm text-gray-500 italic">
          Last Updated: 19-12-2023
        </div> */}
      </div>
    </div>
  );
};

export default InternalComplaint;